export default __webpack_public_path__ + "images/sad_bee.09f61a8.png";